// Cache management utility for Capacitor app
// Clears cache when app version changes

const APP_VERSION_KEY = 'app_version';
const CURRENT_VERSION = '1.0.1'; // Update this when you release new versions

export const clearCacheOnUpdate = async () => {
    try {
        const storedVersion = localStorage.getItem(APP_VERSION_KEY);

        if (storedVersion !== CURRENT_VERSION) {
            console.log(`Version changed from ${storedVersion} to ${CURRENT_VERSION}. Clearing cache...`);

            // Clear all caches
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(
                    cacheNames.map(cacheName => caches.delete(cacheName))
                );
                console.log('Service Worker caches cleared');
            }

            // Clear localStorage except version key
            const versionValue = CURRENT_VERSION;
            localStorage.clear();
            localStorage.setItem(APP_VERSION_KEY, versionValue);
            console.log('LocalStorage cleared');

            // Clear sessionStorage
            sessionStorage.clear();
            console.log('SessionStorage cleared');

            // Clear IndexedDB if used
            if ('indexedDB' in window) {
                try {
                    const databases = await indexedDB.databases();
                    databases.forEach(db => {
                        if (db.name) {
                            indexedDB.deleteDatabase(db.name);
                        }
                    });
                    console.log('IndexedDB cleared');
                } catch (e) {
                    console.warn('Could not clear IndexedDB:', e);
                }
            }

            console.log('Cache cleared successfully!');

            // Force reload to get fresh content
            setTimeout(() => {
                window.location.reload();
            }, 100);
        } else {
            console.log(`App version ${CURRENT_VERSION} - No cache clear needed`);
        }
    } catch (error) {
        console.error('Error clearing cache:', error);
        // Store version anyway to prevent repeated attempts
        localStorage.setItem(APP_VERSION_KEY, CURRENT_VERSION);
    }
};

// Function to manually clear all cache (for development/debugging)
export const forceClearAllCache = async () => {
    try {
        // Clear all caches
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(
                cacheNames.map(cacheName => caches.delete(cacheName))
            );
        }

        // Clear all storage
        localStorage.clear();
        sessionStorage.clear();

        // Clear IndexedDB
        if ('indexedDB' in window) {
            try {
                const databases = await indexedDB.databases();
                databases.forEach(db => {
                    if (db.name) {
                        indexedDB.deleteDatabase(db.name);
                    }
                });
            } catch (e) {
                console.warn('Could not clear IndexedDB:', e);
            }
        }

        console.log('All cache forcefully cleared!');
        window.location.reload();
    } catch (error) {
        console.error('Error force clearing cache:', error);
    }
};

// Get current app version
export const getAppVersion = () => CURRENT_VERSION;
